import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mmb-web-app-edit-profile-action-panel',
  templateUrl: './edit-profile-action-panel.component.html',
  styleUrls: ['./edit-profile-action-panel.component.scss'],
})
export class EditProfileActionPanelComponent implements OnInit {
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
  @Input() value: any;
  
  constructor() { }

  ngOnInit() {
  }

  onClick() {
    this.clicked.emit();
  }
}
